import iconv from 'iconv-lite'
import jschardet from 'jschardet'

export const useReadFile = () => {
  const readFile = (
    file: File,
    encoding: 'utf8' | 'sjis'
  ): Promise<string | ArrayBuffer | null> => {
    /** FileReaderを用いる際async/awaitに対応していないためPromiseでラップした関数を用意する */
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      const readCsv = () => {
        const code = encoding === 'utf8' ? 'utf8' : 'Shift_JIS'
        const csvString = iconv.decode(Buffer.from(reader.result as ArrayBuffer), code)
        resolve(csvString)
      }

      reader.addEventListener('load', readCsv)
      // eslint-disable-next-line unicorn/prefer-add-event-listener
      reader.onerror = error => {
        reject(error)
      }
      reader.readAsArrayBuffer(file)
    })
  }

  const getIsUtf8 = (file: File): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.addEventListener('load', event => {
        const buffer = event.target?.result as ArrayBuffer
        const uint8Array = new Uint8Array(buffer)
        const bufferForDetect = Buffer.from(uint8Array)

        // エンコーディングを判別する
        const result = jschardet.detect(bufferForDetect)
        // eslint-disable-next-line unicorn/text-encoding-identifier-case
        resolve(result.encoding === 'UTF-8')
      })

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      reader.onerror = error => {
        reject(error)
      }

      // バイナリ形式でファイルを読み込む
      reader.readAsArrayBuffer(file)
    })
  }

  const getIsSjis = (file: File): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.addEventListener('load', event => {
        const buffer = event.target?.result as ArrayBuffer
        const uint8Array = new Uint8Array(buffer)
        const bufferForDetect = Buffer.from(uint8Array)

        // エンコーディングを判別する
        const result = jschardet.detect(bufferForDetect)
        // eslint-disable-next-line unicorn/text-encoding-identifier-case
        resolve(result.encoding === 'SHIFT_JIS')
      })

      // eslint-disable-next-line unicorn/prefer-add-event-listener
      reader.onerror = error => {
        reject(error)
      }

      // バイナリ形式でファイルを読み込む
      reader.readAsArrayBuffer(file)
    })
  }

  return {
    readFile,
    getIsUtf8,
    getIsSjis,
  }
}
